import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { requestPassword } from '../core/_requests'
import { REQUIRED_FILED } from 'app/constants/errorConstants'
import MusaLoader from '../../../components/loader/MusaLoader'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email('Formato de correo electrónico incorrecto').required(REQUIRED_FILED),
})

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)

  const generateToken = () => {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (var i = 15; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        const resetToken = generateToken();
        const data = {
          email: values.email,
          resetToken: resetToken,
        }
        requestPassword(data)
          .then(({ data }) => {
            if (data?.success) {
              setHasErrors(false)
              setLoading(false)
            } else {
              throw Error
            }
          })
          .catch(() => {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect')
          })
      }, 1000)
    },
  })

  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          <h1 className='text-dark mb-3'>¿ Has olvidado tu contraseña ?</h1>

          <div className='text-gray-600 fw-bold fs-4'>Ingrese su correo electrónico para restablecer su contraseña.</div>
        </div>

        <div className='fv-row mb-10'>
          <label className='form-label fw-bolder text-gray-900 fs-6'>Correo Electronico</label>
          <input
            type='email'
            placeholder=''
            autoComplete='off'
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control bg-transparent',
              { 'is-invalid': formik.touched.email && formik.errors.email },
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
          />
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.email}</span>
              </div>
            </div>
          )}
        </div>

        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <button
            type='submit'
            id='kt_password_reset_submit'
            className='btn btn-lg btn-primary fw-bolder me-4'
          >
            <span className='indicator-label'>Continuar</span>
            {loading && (
              <span className='indicator-progress'>
                <MusaLoader size={34} label={null} className='align-middle' />
              </span>
            )}
          </button>
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-lg btn-light-primary fw-bolder'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              Cancelar
            </button>
          </Link>
        </div>

        <div className="mt-lg-10">
          {hasErrors === true && (
            <div className='alert alert-danger'>
              <div className='alert-text font-weight-bold'>
                Lo sentimos, parece que se han detectado algunos errores, inténtalo de nuevo.
              </div>
            </div>
          )}

          {hasErrors === false && (
            <div className='bg-light-info p-8 rounded'>
              <div className='fw-bold' style={{color: '#506936'}}>Restablecimiento de contraseña enviado. Por favor revise su correo electrónico</div>
            </div>
          )}
        </div>
      </form>
    </>
  )
}
